<template>
  <div class="tab_content">
    <p class="tab_title">项目基本信息</p>
    <div class="tab_form">
      <el-form ref="form" :rules="rules" :model="form" label-width="160px">

        <el-form-item label="项目名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入" />
        </el-form-item>

        <el-form-item prop="dealWay">
          <div slot="label">
            <span style="color: #f56c6c">* </span>业务类型
          </div>
          <el-checkbox-group v-model="form.dealWay" @change="syncToParent">
            <el-checkbox label="转让">转让</el-checkbox>
            <el-checkbox label="许可">许可</el-checkbox>
            <el-checkbox label="作价入股">作价入股</el-checkbox>
            <el-checkbox label="其他">其他</el-checkbox>
          </el-checkbox-group>
          <el-input
            v-if="form.dealWay.includes('其他')"
            v-model="form.dealWayExtra"
            placeholder="请输入其他业务类型说明"
            style="width: 300px; margin-top: 8px"
            @input="syncToParent"
          />
        </el-form-item>

        <el-form-item label="项目领域">
          <el-checkbox-group v-model="form.projectDomain">
            <el-checkbox label="生物医药">生物医药</el-checkbox>
            <el-checkbox label="先进制造">先进制造</el-checkbox>
            <el-checkbox label="新材料">新材料</el-checkbox>
            <el-checkbox label="新能源">新能源</el-checkbox>
            <el-checkbox label="农业科技">农业科技</el-checkbox>
            <el-checkbox label="人工智能">人工智能</el-checkbox>
            <el-checkbox label="航空航天">航空航天</el-checkbox>
            <el-checkbox label="信息技术">信息技术</el-checkbox>
            <el-checkbox label="集成电路">集成电路</el-checkbox>
            <el-checkbox label="文体综合">文体综合</el-checkbox>
            <el-checkbox label="其他">其他</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="项目简介">
          <el-input
            v-model="form.projectBrief"
            type="textarea"
            :rows="4"
            placeholder="请输入"
          />
        </el-form-item>

        <div class="button flex-center">
          <el-button type="primary" @click="$emit('aChange', 'tab1')">上一步</el-button>
          <el-button type="primary" @click="doStaging('form')">暂存</el-button>
          <el-button type="primary" @click="doSubmit('form')">下一步</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  props: ["id", "cfrom"],
  data() {
    return {
      form: {
        name: "",
        dealWay: [],
        dealWayExtra: "",
        projectDomain: [],
        projectBrief: "",
      },
      rules: {
        name: [{ required: true, message: "请输入项目名称" }],
      },
    };
  },
  methods: {
    buildValue() {
      const v = { ...this.form };
      if (!v.dealWay.includes("其他")) v.dealWayExtra = "";
      v.dealWay = v.dealWay.join(",");
      v.projectDomain = v.projectDomain.join(",");
      if (this.id) v.id = this.id;
      return v;
    },
    doStaging(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("aStagin", this.buildValue());
        }
      });
    },
    doSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        if (this.form.dealWay.length === 0) {
          this.$message.error("请至少选择一种业务类型");
          return;
        }
        this.$emit("aChange", "tab3", this.buildValue());
      });
    },
    syncToParent() {
      this.$emit("aSync", this.buildValue());
    },
  },
  watch: {
    cfrom() {
      if (!this.cfrom || !this.cfrom.id) return;
      const dealWay = this.cfrom.dealWay
        ? this.cfrom.dealWay.split(",").filter(Boolean)
        : [];
      const projectDomain = this.cfrom.projectDomain
        ? this.cfrom.projectDomain.split(",").filter(Boolean)
        : [];
      this.form = {
        name: this.cfrom.name || "",
        dealWay,
        dealWayExtra: this.cfrom.dealWayExtra || "",
        projectDomain,
        projectBrief: this.cfrom.projectBrief || "",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tab_content {
  margin: 0 30px;
  .tab_title {
    font-size: 18px;
    font-weight: 500;
  }
  .tab_form {
    margin-top: 20px;
    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
  }
}
</style>
